import React from 'react'
import { appendTenantIdToPath, openWithTenant } from '@app-store'
import { CustomButton, Modal } from '@ui-kit'
import { RootState, useAppSelector } from '../../utils/agent.store'
import { ENTITY_ID, INTEGRATION_LOGS } from '../../utils/constants'
import { CommunicationLogCase } from '../../utils/integrationLogs.utils'

interface AssociatedCaseIdsModalProps {
  isOpen: boolean
  closeModal: () => void
  cases: CommunicationLogCase[]
  title?: string
}

export const AssociatedCaseIdsModal: React.FC<AssociatedCaseIdsModalProps> = ({
  isOpen,
  closeModal,
  cases,
  title = INTEGRATION_LOGS.ASSOCIATED_CASE_IDS_TITLE,
}) => {
  const tenantId = useAppSelector(
    (state: RootState) => state.authUser?.selectedClientTenant?.id
  )

  const openCaseReview = (caseRecordId: number) => {
    openWithTenant(
      appendTenantIdToPath(
        `entity/${ENTITY_ID.CASE}/workflow/review/${caseRecordId}`,
        tenantId
      ),
      '_blank'
    )
  }

  return (
    <Modal isOpen={isOpen} closeModal={closeModal} isDragable>
      <div className="w-[28rem] flex flex-col rounded-[0.25rem]">
        <div className="flex justify-between items-center px-4 py-3">
          <h2 className="text-base font-semibold">{title}</h2>
          <CustomButton onClick={closeModal}>Close</CustomButton>
        </div>

        <div className="h-[0.0625rem] bg-gray-200" />

        <div className="p-4">
          {cases.length ? (
            <p className="text-sm text-accent-900 break-words">
              {cases.map((caseItem, index) => {
                const caseKey = caseItem.case_key
                const caseRecordId = caseItem.id

                if (!caseKey) return null

                return (
                  <span key={`${caseRecordId ?? caseKey}-${index}`}>
                    {index > 0 && ', '}
                    {caseRecordId ? (
                      <span
                        className="text-sm font-medium text-border-50 cursor-pointer"
                        onClick={() => openCaseReview(caseRecordId)}
                      >
                        {caseKey}
                      </span>
                    ) : (
                      <span>{caseKey}</span>
                    )}
                  </span>
                )
              })}
            </p>
          ) : (
            <p className="text-sm text-accent-900">
              {INTEGRATION_LOGS.NO_ASSOCIATED_CASE_IDS}
            </p>
          )}
        </div>
      </div>
    </Modal>
  )
}
